import { useEffect } from 'react';
import { useBlocker } from 'react-router';

const useFormBlock: Function = (
  onFormLeave: Function, isFormChanged: boolean, isFormStateChanged: boolean, isLeaveConfirmed: boolean,
  isLeaveConfirmModalOpen: boolean,
): void => {
  const BLOCKER_STATE_BLOCKED: string = 'blocked';

  const routerBlocker: ReactRouterBlocker = useBlocker(({ currentLocation, nextLocation }): boolean => (
    (isFormChanged || isFormStateChanged) && currentLocation.pathname !== nextLocation.pathname
  ));
  const isRouterBlocked: boolean = routerBlocker.state === BLOCKER_STATE_BLOCKED;
  const lastLocation: string | undefined = routerBlocker ? routerBlocker.location : undefined;

  useEffect((): void => {
    if (onFormLeave && isRouterBlocked) {
      onFormLeave(lastLocation);

      if (isFormStateChanged && !isFormChanged) {
        routerBlocker.proceed();
      }
    }
  }, [isRouterBlocked]);

  useEffect((): void => {
    if (!isLeaveConfirmModalOpen && !isLeaveConfirmed && isRouterBlocked) {
      routerBlocker.reset();
    }
  }, [isLeaveConfirmModalOpen]);

  useEffect((): void => {
    if (isLeaveConfirmed && isRouterBlocked) {
      routerBlocker.proceed();
    }
  }, [isLeaveConfirmed]);
};

export default useFormBlock;
